// extracted by mini-css-extract-plugin
export default {"admin":"Admin_admin__Hz2oP","navbar":"Admin_navbar__78BER","content":"Admin_content__BcT0x"};